/**
 * Generated runtime TestId mirror for frontend/src/components/identity/IdentityLifecycleHeader.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const IdentityLifecycleHeaderTestIds = {
  lifecycleHeaderActor: "lifecycle-header-actor",
  lifecycleHeaderFromState: "lifecycle-header-from-state",
  lifecycleHeaderReason: "lifecycle-header-reason",
  lifecycleHeaderSummary: "lifecycle-header-summary",
  lifecycleHeaderTimestamp: "lifecycle-header-timestamp",
  lifecycleHeaderToState: "lifecycle-header-to-state",
  lifecycleHeaderTriggerSource: "lifecycle-header-trigger-source",
  lifecycleHeaderViewTimeline: "lifecycle-header-view-timeline",
  skeleton: (root: string) => `${root}-skeleton`,
  unavailable: (root: string) => `${root}-unavailable`
} as const;
